import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CancelOpsOrderMutationVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OpsOrderFilter>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type CancelOpsOrderMutation = { __typename?: 'Mutation', cancelOpsOrder: boolean };


export const CancelOpsOrderDocument = gql`
    mutation CancelOpsOrder($filter: OpsOrderFilter, $ids: [ID!]) {
  cancelOpsOrder(filter: $filter, ids: $ids)
}
    `;
export type CancelOpsOrderMutationFn = Apollo.MutationFunction<CancelOpsOrderMutation, CancelOpsOrderMutationVariables>;

/**
 * __useCancelOpsOrderMutation__
 *
 * To run a mutation, you first call `useCancelOpsOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOpsOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOpsOrderMutation, { data, loading, error }] = useCancelOpsOrderMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCancelOpsOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelOpsOrderMutation, CancelOpsOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOpsOrderMutation, CancelOpsOrderMutationVariables>(CancelOpsOrderDocument, options);
      }
export type CancelOpsOrderMutationHookResult = ReturnType<typeof useCancelOpsOrderMutation>;
export type CancelOpsOrderMutationResult = Apollo.MutationResult<CancelOpsOrderMutation>;
export type CancelOpsOrderMutationOptions = Apollo.BaseMutationOptions<CancelOpsOrderMutation, CancelOpsOrderMutationVariables>;